module.exports = __webpack_public_path__ + "img/morphine.c049f051.png";